const BRAND_ASSETS_BASE_URL = 'https://brand-assets.paywithextend.com'

export type MarcomPresentedPartner =
  | 'AMEX'
  | 'CNB'
  | 'TCB'
  | 'HSBC'
  | 'MASTERCARD'

export interface MarcomPartnerPresentation {
  partner: MarcomPresentedPartner
  cardArtUrl: string
}

const CNB_PRESENTATION: MarcomPartnerPresentation = {
  partner: 'CNB',
  cardArtUrl: `${BRAND_ASSETS_BASE_URL}/cnb/CardArt.png`,
}

const MARCOM_PARTNER_PRESENTATIONS: Record<
  string,
  MarcomPartnerPresentation
> = {
  AMEX: {
    partner: 'AMEX',
    cardArtUrl: `${BRAND_ASSETS_BASE_URL}/amex/CardArt.png`,
  },
  CNB: CNB_PRESENTATION,
  TCB: {
    partner: 'TCB',
    cardArtUrl: `${BRAND_ASSETS_BASE_URL}/tcb/CardArt.png`,
  },
  HSBC: {
    partner: 'HSBC',
    cardArtUrl: `${BRAND_ASSETS_BASE_URL}/hsbc/CardArt.png`,
  },
  MASTERCARD: {
    partner: 'MASTERCARD',
    cardArtUrl: `${BRAND_ASSETS_BASE_URL}/mastercard/CardArt.png`,
  },
  // APT is a staging-only CNB-equivalent test issuer and must never become
  // customer-facing branding of its own.
  APT: CNB_PRESENTATION,
}

export const MARCOM_CARD_ART_URLS = Array.from(
  new Set(
    Object.values(MARCOM_PARTNER_PRESENTATIONS).map(
      (presentation) => presentation.cardArtUrl,
    ),
  ),
)

export function resolveMarcomPartnerPresentation(
  partnerName?: string | null,
): MarcomPartnerPresentation | undefined {
  const normalizedPartnerName = partnerName?.trim().toUpperCase()

  return normalizedPartnerName
    ? MARCOM_PARTNER_PRESENTATIONS[normalizedPartnerName]
    : undefined
}
